<template>
  <div class="module-wrap">
    <div class="sub-title">竞企信息</div>
    <el-button type="text" size="medium" v-show="competitorsData.length<=14" @click="$emit('add')"
      >添加竞企</el-button
    >

    <div class="table">
      <el-table :data="competitorsData" width="50">
        <!-- 操作列 -->
        <el-table-column prop="" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="$emit('remove', scope.$index)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>

        <!-- 竞企名称 -->
        <el-table-column prop="competitorsId" label="竞企名称" width="300">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.competitorsId"
              placeholder="请选择竞企"
              filterable
              clearable
              @change="(value) => handleCompetitorChange(value, scope.row)"
            >
              <el-option
                v-for="competitor in competitorsList"
                :key="competitor.id"
                :label="competitor.competitorsName"
                :value="competitor.id"
              />
            </el-select>
          </template>
        </el-table-column>

        <!-- 收货价格信息 -->
        <el-table-column
          prop="singleAirconditionRecyclePrice"
          label="收货价(单片空调)"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.singleAirconditionRecyclePrice"
              type="number"
              maxlength="10"
            >
              <template slot="append">元/KG</template></el-input
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="doubleAirconditionRecyclePrice"
          label="收货价(双片空调)"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.doubleAirconditionRecyclePrice"
              type="number"
              maxlength="10"
            >
              <template slot="append">元/KG</template></el-input
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompetitiveInfoSection",

  props: {
    competitorsData: {
      type: Array,
      required: true,
    },
    competitorsList: {
      type: Array,
      required: true,
    },
  },

  methods: {
    handleCompetitorChange(value, row) {
      this.$emit("update:competitor-name", row);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/dataBoard/components/CompetitiveInfoSection.vue